"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mx-auto mb-4 mt-6 w-full max-w-[328px]" };
const _hoisted_2 = { class: "text-xs leading-4.5 text-gray-70" };
const _hoisted_3 = { class: "text-xs leading-4.5 text-gray-70" };
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BaseFootnote',
    setup(__props) {
        const aboutUsURL = (0, main_1.$t)("foot_note.about_us_url");
        const aboutUsLink = `${window.location.origin}${aboutUsURL}`;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)("foot_note.recommended_retail_price")), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)("foot_note.biggest_outlet_explanation")) + " ", 1),
                    (0, vue_2.createElementVNode)("a", {
                        href: aboutUsLink,
                        class: "break-words underline",
                        target: "_blank",
                        rel: "noopener"
                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)("foot_note.more_information")), 1)
                ])
            ]));
        };
    }
});
